import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';
import { getCmFields } from './helpers/getCmFields';

export const cmMidPointBeacon = (action) => {
  const { adBreakDuration, ad, adIndex } = action.payload;
  const cmFields = getCmFields({ adBreakDuration, ad, adIndex });
  return {
    hitType: HIT_TYPE.EVENT,
    eventCategory: EVENT_CATEGORIES.CM,
    eventName: EVENT_NAMES.CM_MID_POINT,
    ...cmFields,
  };
};
